import HtmlIcon from './HtmlSvg';
import ImageIcon from './ImageSvg';
import JsonIcon from './jsonSvg';
import MarkdownIcon from './MarkdownSvg';
import Mp3Icon from './Mp3Svg';
import Mp4Icon from './Mp4Svg';
import AIIcon from './AIIcon';
import ScoreSuccess from './ScoreSuccess';
import OtherIcon from './OtherSvg';
import PdfIcon from './PdfSvg';
import PPTIcon from './PPTSvg';
import PSIcon from './PSSvg';
import TxtIcon from './TxtSvg';
import UploadErrorIcon from './UploadErrorSvg';
import DownloadFailIcon from './DownloadFailIcon';
import WordIcon from './WordSvg';
import XlsIcon from './XlsSvg';
import ImportDocIcon from './ImportDoc';
import { LxXlsIcon, LxDocIcon, LxUnitableIcon } from './LxDocsSvg';
import DownloadIcon from './DownloadSvg';
import UploadIcon from './UploadSvg';
import MoreIcon from './MoreSvg';
import ZipIcon from './ZipSvg';
import SaveIcon from './SaveSvg';
import AmplificationIcon from './Amplification';
import PreviousIcon from './PreviousSvg';
import NextIcon from './NextSvg';
import RotateLeft from './RotateLeft';
import OpenIcon from './OpenSvg';
import CloseIcon from './ClosePreview';
import DoDownloadIcon from './DoDownloadSvg';
import ShrinkIcon from './Shrink';
import OriginalIcon from './Original';
import DiskIcons from './disk';
import SendEmailSvg from './SendEmailSvg';
import ContactLeft from './ContactLeft';
import ContactRight from './ContactRight';
import Browser from './Browser';
import File from './File';
import IconFolder from './IconFolder';
import FilterTriangleDown from './FilterTriangleDown';
import Camera from './Camera';
import Account from './Account';
import Expand from './Expand';
import Collapse from './Collapse';
import Inbox from './Inbox';
import StarGray from './StarGray';
import StarGold from './StarGold';
import Brush from './Brush';
import InfoTips from './InfoTips';
import TemplateIcon from './Template';
import Alarm from './Alarm';
import EmlIcon from './Eml';
import TaskIcon from './TaskMailSvg';
import Conference from './Conference';
import AddMember from './AddMember';
import Mark from './Mark';
import MailExchange from './MailExchange';
import Question from './Question';
import CircleSub from './CircleSub';
import CirclePlus from './CirclePlus';
import AllipseGroup from './AllipseGroup';
import Discuss from './Discuss';
import GreenDiscuss from './GreenDiscuss';
import Descend from './Descend';
import Ascend from './Ascend';
import Chat from './Chat';
import MaxEditor from './MaxEditor';
import MinEditor from './MinEditor';
import ContentAssistantRight from './ContentAssistantRight';
import ContentAssistantLeft from './ContentAssistantLeft';
import MailIcons from './mail';
import WarnYellow from './WarnYellow';
import MailMain from './MailMain';
import Mail163 from './Mail163';
import MailQq from './MailQq';
import MailOther from './MailOther';
import ResetSearch from './ResetSearch';
import ArrowUp from './ArrowUp';
import ArrowDown from './ArrowDown';
import CrmClient from './CrmClient';
import MailComment from './MailComment';
import HintClient from './HintClient';
import HoverShuru from './HoverShuru';
import TongyongZhankaiYou from '@web-common/images/newIcon/tongyong_zhankai_you';
import TongyongZhankaiZuo from '@web-common/images/newIcon/tongyong_zhankai_zuo';
import { ReactComponent as Jiantouyidong } from '@web-common/images/newIcon/jiantouyidong.svg';
import { ReactComponent as TongyongCuowutishiXian } from '@web-common/images/newIcon/tongyong_cuowutishi_xian.svg';
import { ReactComponent as TongyongQingchu } from '@web-common/images/newIcon/tongyong_qingchu.svg';
import { ReactComponent as TongyongYouxiang2 } from '@web-common/images/newIcon/tongyong_youxiang2.svg';
import { ReactComponent as TongyongJiantouShang } from '@web-common/images/newIcon/tongyong_jiantou_shang.svg';
import { ReactComponent as TongyongZuixiaohua2 } from '@web-common/images/newIcon/tongyong_zuixiaohua2.svg';
import { ReactComponent as TongyongCaogao } from '@web-common/images/newIcon/tongyong_caogao.svg';
import { ReactComponent as TongyongShezhi } from '@web-common/images/newIcon/tongyong_shezhi.svg';
import { ReactComponent as TongyongDizhibu } from '@web-common/images/newIcon/tongyong_dizhibu.svg';
import { ReactComponent as TongyongXiansuo } from '@web-common/images/newIcon/tongyong_xiansuo.svg';
import { ReactComponent as TongyongXiaoxi } from '@web-common/images/newIcon/tongyong_xiaoxi.svg';
import { ReactComponent as TongyongBaocun } from '@web-common/images/newIcon/tongyong_baocun.svg';
import { ReactComponent as TongyongFangda } from '@web-common/images/newIcon/tongyong_fangda.svg';
import { ReactComponent as TongyongFanyi } from '@web-common/images/newIcon/tongyong_fanyi.svg';
import { ReactComponent as TongyongShuomingMian } from '@web-common/images/newIcon/tongyong_shuoming_mian.svg';
import { ReactComponent as TongyongDingyuechenggong } from '@web-common/images/newIcon/tongyong_dingyuechenggong.svg';
import { ReactComponent as TongyongRili3 } from '@web-common/images/newIcon/tongyong_rili3.svg';
import { ReactComponent as TongyongTianjia } from '@web-common/images/newIcon/tongyong_tianjia.svg';
import { ReactComponent as TongyongBiaoqianMian } from '@web-common/images/newIcon/tongyong_biaoqian_mian.svg';
import { ReactComponent as TongyongShift } from '@web-common/images/newIcon/tongyong_shift.svg';
import { ReactComponent as TongyongKuaijie } from '@web-common/images/newIcon/tongyong_kuaijie.svg';
import { ReactComponent as TongyongDianzanMianxing } from '@web-common/images/newIcon/tongyong_dianzan_mianxing.svg';
import { ReactComponent as BianjiJuhe } from '@web-common/images/newIcon/bianji_juhe.svg';
import { ReactComponent as TongyongJiantouYou1 } from '@web-common/images/newIcon/tongyong_jiantou_you1.svg';
import { ReactComponent as TongyongRili2 } from '@web-common/images/newIcon/tongyong_rili2.svg';
import { ReactComponent as TongyongDaochu } from '@web-common/images/newIcon/tongyong_daochu.svg';
import { ReactComponent as TongyongDingyuerili } from '@web-common/images/newIcon/tongyong_dingyuerili.svg';
import { ReactComponent as TongyongFuzhi } from '@web-common/images/newIcon/tongyong_fuzhi.svg';
import { ReactComponent as TongyongBiaoqing } from '@web-common/images/newIcon/tongyong_biaoqing.svg';
import { ReactComponent as TongyongJiantouZuo1 } from '@web-common/images/newIcon/tongyong_jiantou_zuo1.svg';
import TongyongDizhi from '@web-common/images/newIcon/tongyong_dizhi';
import { ReactComponent as TongyongXuanzhuan } from '@web-common/images/newIcon/tongyong_xuanzhuan.svg';
import { ReactComponent as JichuJiagou } from '@web-common/images/newIcon/jichu_jiagou.svg';
import { ReactComponent as Schedule } from '@web-common/images/newIcon/schedule.svg';
import { ReactComponent as TongyongYouxiang4 } from '@web-common/images/newIcon/tongyong_youxiang4.svg';
import { ReactComponent as TongyongShanchuMian1 } from '@web-common/images/newIcon/tongyong_shanchu_mian1.svg';
import { ReactComponent as TongyongChanpinguanli } from '@web-common/images/newIcon/tongyong_chanpinguanli.svg';
import { ReactComponent as TongyongJiantouShang1 } from '@web-common/images/newIcon/tongyong_jiantou_shang1.svg';
import { ReactComponent as TongyongXiaoxi3Xian1 } from '@web-common/images/newIcon/tongyong_xiaoxi3_xian1.svg';
import { ReactComponent as TongyongXingxingMian } from '@web-common/images/newIcon/tongyong_xingxing_mian.svg';
import { ReactComponent as TongyongShouji } from '@web-common/images/newIcon/tongyong_shouji.svg';
import { ReactComponent as TongyongLianjie } from '@web-common/images/newIcon/tongyong_lianjie.svg';
import { ReactComponent as TongyongRenwu1 } from '@web-common/images/newIcon/tongyong_renwu1.svg';
import { ReactComponent as TongyongBianjiMian } from '@web-common/images/newIcon/tongyong_bianji_mian.svg';
import { ReactComponent as TongyongYouxiang5Xian } from '@web-common/images/newIcon/tongyong_youxiang5_xian.svg';
import { ReactComponent as TongyongQiye } from '@web-common/images/newIcon/tongyong_qiye.svg';
import { ReactComponent as TongyongYouxiang6 } from '@web-common/images/newIcon/tongyong_youxiang6.svg';
import { ReactComponent as TongyongDulichuangkou } from '@web-common/images/newIcon/tongyong_dulichuangkou.svg';
import { ReactComponent as TongyongShezhi2Mian } from '@web-common/images/newIcon/tongyong_shezhi2_mian.svg';
import { ReactComponent as bianjiHuifu } from '@web-common/images/newIcon/bianji_huifu.svg';
import { ReactComponent as TongyongShaixuan } from '@web-common/images/newIcon/tongyong_shaixuan.svg';
import { ReactComponent as TongyongYuyin } from '@web-common/images/newIcon/tongyong_yuyin.svg';
import { ReactComponent as TongyongShuangjiantouShang } from '@web-common/images/newIcon/tongyong_shuangjiantou_shang.svg';
import { ReactComponent as TongyongRenyuan10 } from '@web-common/images/newIcon/tongyong_renyuan10.svg';
import { ReactComponent as TongyongPaizhao } from '@web-common/images/newIcon/tongyong_paizhao.svg';
import { ReactComponent as TongyongBiaoqian2Xian } from '@web-common/images/newIcon/tongyong_biaoqian2_xian.svg';
import { ReactComponent as TongyongYiwenMian } from '@web-common/images/newIcon/tongyong_yiwen_mian.svg';
import { ReactComponent as TongyongYouxian } from '@web-common/images/newIcon/tongyong_youxian.svg';
import { ReactComponent as TongyongDiqiu } from '@web-common/images/newIcon/tongyong_diqiu.svg';
import { ReactComponent as TongyongHoutai } from '@web-common/images/newIcon/tongyong_houtai.svg';
import { ReactComponent as TongyongGongju } from '@web-common/images/newIcon/tongyong_gongju.svg';
import { ReactComponent as BianjiHongqiXian } from '@web-common/images/newIcon/bianji_hongqi_xian.svg';
import { ReactComponent as TongyongRenyuan11 } from '@web-common/images/newIcon/tongyong_renyuan11.svg';
import { ReactComponent as TongyongFasong } from '@web-common/images/newIcon/tongyong_fasong.svg';
import { ReactComponent as TongyongZuixiaohua } from '@web-common/images/newIcon/tongyong_zuixiaohua.svg';
import { ReactComponent as TongyongRenwu } from '@web-common/images/newIcon/tongyong_renwu.svg';
import TongyongShijianXian from '@web-common/images/newIcon/tongyong_shijian_xian';
import { ReactComponent as TongyongOcr } from '@web-common/images/newIcon/tongyong_OCR.svg';
import { ReactComponent as TongyongShuru } from '@web-common/images/newIcon/tongyong_shuru.svg';
import { ReactComponent as TongyongXiaoxi3Xian } from '@web-common/images/newIcon/tongyong_xiaoxi3_xian.svg';
import { ReactComponent as TongyongShoujianxiang } from '@web-common/images/newIcon/tongyong_shoujianxiang.svg';
import { ReactComponent as TongyongZhankaiXian } from '@web-common/images/newIcon/tongyong_zhankai_xian.svg';
import { ReactComponent as TongyongShangchuan } from '@web-common/images/newIcon/tongyong_shangchuan.svg';
import { ReactComponent as TongyongWenjianjia } from '@web-common/images/newIcon/tongyong_wenjianjia.svg';
import { ReactComponent as TongyongZuidahua } from '@web-common/images/newIcon/tongyong_zuidahua.svg';
import { ReactComponent as TongyongKuaijiejian } from '@web-common/images/newIcon/tongyong_kuaijiejian.svg';
import { ReactComponent as TongyongZuidahua2 } from '@web-common/images/newIcon/tongyong_zuidahua2.svg';
import { ReactComponent as TongyongQueren } from '@web-common/images/newIcon/tongyong_queren.svg';
import { ReactComponent as TongyongSuoGuan } from '@web-common/images/newIcon/tongyong_suo_guan.svg';
import { ReactComponent as TongyongShangchuan2Xian } from '@web-common/images/newIcon/tongyong_shangchuan2_xian.svg';
import { ReactComponent as TongyongFaqizhe } from '@web-common/images/newIcon/tongyong_faqizhe.svg';
import { ReactComponent as TongyongQuxiaozhiding } from '@web-common/images/newIcon/tongyong_quxiaozhiding.svg';
import { ReactComponent as TongyongTianjiaXian } from '@web-common/images/newIcon/tongyong_tianjia_xian.svg';
import { ReactComponent as TongyongRili } from '@web-common/images/newIcon/tongyong_rili.svg';
import { ReactComponent as TongyongCommand } from '@web-common/images/newIcon/tongyong_command.svg';
import { ReactComponent as TongyongChenggongXian } from '@web-common/images/newIcon/tongyong_chenggong_xian.svg';
import { ReactComponent as TongyongGengduo2 } from '@web-common/images/newIcon/tongyong_gengduo2.svg';
import { ReactComponent as TongyongGuanbiXian } from '@web-common/images/newIcon/tongyong_guanbi_xian.svg';
import { ReactComponent as TongyongWangluoyichangXian } from '@web-common/images/newIcon/tongyong_wangluoyichang_xian.svg';
import { ReactComponent as TongyongRenyuan9 } from '@web-common/images/newIcon/tongyong_renyuan9.svg';
import { ReactComponent as TongyongShanchuXian } from '@web-common/images/newIcon/tongyong_shanchu_xian.svg';
import { ReactComponent as TongyongGaojisousuo } from '@web-common/images/newIcon/tongyong_gaojisousuo.svg';
import { ReactComponent as TongyongBofang } from '@web-common/images/newIcon/tongyong_bofang.svg';
import { ReactComponent as TongyongShuju } from '@web-common/images/newIcon/tongyong_shuju.svg';
import { ReactComponent as TongyongRenyuan8 } from '@web-common/images/newIcon/tongyong_renyuan8.svg';
import { ReactComponent as TongyongJianshao } from '@web-common/images/newIcon/tongyong_jianshao.svg';
import { ReactComponent as TongyongChanpin2 } from '@web-common/images/newIcon/tongyong_chanpin2.svg';
import { ReactComponent as TongyongXunhuan } from '@web-common/images/newIcon/tongyong_xunhuan.svg';
import { ReactComponent as TongyongJingshi } from '@web-common/images/newIcon/tongyong_jingshi.svg';
import { ReactComponent as TongyongZhankaiShang } from '@web-common/images/newIcon/tongyong_zhankai_shang.svg';
import { ReactComponent as TongyongTupian } from '@web-common/images/newIcon/tongyong_tupian.svg';
import { ReactComponent as TongyongRenyuan5 } from '@web-common/images/newIcon/tongyong_renyuan5.svg';
import { ReactComponent as TongyongBiaoqianXian } from '@web-common/images/newIcon/tongyong_biaoqian_xian.svg';
import { ReactComponent as TongyongLishijilu } from '@web-common/images/newIcon/tongyong_lishijilu.svg';
import { ReactComponent as TongyongWendang } from '@web-common/images/newIcon/tongyong_wendang.svg';
import { ReactComponent as Jiantoujinyong } from '@web-common/images/newIcon/jiantoujinyong.svg';
import { ReactComponent as TongyongRenyuan4 } from '@web-common/images/newIcon/tongyong_renyuan4.svg';
import { ReactComponent as TongyongShijianMianxing } from '@web-common/images/newIcon/tongyong_shijian_mianxing.svg';
import { ReactComponent as TongyongFenxiang } from '@web-common/images/newIcon/tongyong_fenxiang.svg';
import { ReactComponent as TongyongXunzhang } from '@web-common/images/newIcon/tongyong_xunzhang.svg';
import { ReactComponent as TongyongShuangjiantouZuo } from '@web-common/images/newIcon/tongyong_shuangjiantou_zuo.svg';
import { ReactComponent as TongyongShouqiXian } from '@web-common/images/newIcon/tongyong_shouqi_xian.svg';
import { ReactComponent as TongyongYuedu } from '@web-common/images/newIcon/tongyong_yuedu.svg';
import { ReactComponent as TongyongFasongMianxing } from '@web-common/images/newIcon/tongyong_fasong_mianxing.svg';
import { ReactComponent as TongyongCuowutishiMian } from '@web-common/images/newIcon/tongyong_cuowutishi_mian.svg';
import { ReactComponent as TongyongRenyuan6 } from '@web-common/images/newIcon/tongyong_renyuan6.svg';
import TongyongShuaxin from '@web-common/images/newIcon/tongyong_shuaxin';
import { ReactComponent as TongyongZhankaiXia } from '@web-common/images/newIcon/tongyong_zhankai_xia.svg';
import { ReactComponent as BianjiZhuanfa } from '@web-common/images/newIcon/bianji_zhuanfa.svg';
import { ReactComponent as TongyongMokuai } from '@web-common/images/newIcon/tongyong_mokuai.svg';
import { ReactComponent as TongyongYingwen } from '@web-common/images/newIcon/tongyong_yingwen.svg';
import { ReactComponent as TongyongRenyuan7 } from '@web-common/images/newIcon/tongyong_renyuan7.svg';
import { ReactComponent as TongyongLianglan } from '@web-common/images/newIcon/tongyong_lianglan.svg';
import { ReactComponent as TongyongDaoru } from '@web-common/images/newIcon/tongyong_daoru.svg';
import { ReactComponent as TongyongShuju2 } from '@web-common/images/newIcon/tongyong_shuju2.svg';
import { ReactComponent as Shuruguangbiao } from '@web-common/images/newIcon/shuruguangbiao.svg';
import { ReactComponent as TongyongShuomingXian } from '@web-common/images/newIcon/tongyong_shuoming_xian.svg';
import { ReactComponent as TongyongBangzhufankui } from '@web-common/images/newIcon/tongyong_bangzhufankui.svg';
import { ReactComponent as TongyongXiaoxi2Mian1 } from '@web-common/images/newIcon/tongyong_xiaoxi2_mian1.svg';
import { ReactComponent as TongyongXinjianwenjianjia } from '@web-common/images/newIcon/tongyong_xinjianwenjianjia.svg';
import { ReactComponent as TongyongDiannao } from '@web-common/images/newIcon/tongyong_diannao.svg';
import { ReactComponent as TongyongRenyuan3 } from '@web-common/images/newIcon/tongyong_renyuan3.svg';
import { ReactComponent as TongyongShujutongji } from '@web-common/images/newIcon/tongyong_shujutongji.svg';
import { ReactComponent as TongyongYouxiang5Mian } from '@web-common/images/newIcon/tongyong_youxiang5_mian.svg';
import { ReactComponent as TongyongShezhi2Xian } from '@web-common/images/newIcon/tongyong_shezhi2_xian.svg';
import { ReactComponent as Subscribe } from '@web-common/images/newIcon/subscribe.svg';
import { ReactComponent as TongyongRenyuan2 } from '@web-common/images/newIcon/tongyong_renyuan2.svg';
import { ReactComponent as TongyongZhaiyao } from '@web-common/images/newIcon/tongyong_zhaiyao.svg';
import { ReactComponent as TongyongWhatsapp } from '@web-common/images/newIcon/tongyong_WhatsApp.svg';
import { ReactComponent as TongyongYiwen } from '@web-common/images/newIcon/tongyong_yiwen.svg';
import { ReactComponent as TongyongXianshi } from '@web-common/images/newIcon/tongyong_xianshi.svg';
import { ReactComponent as TongyongZhongwen } from '@web-common/images/newIcon/tongyong_zhongwen.svg';
import { ReactComponent as TongyongJiantouZuo } from '@web-common/images/newIcon/tongyong_jiantou_zuo.svg';
import { ReactComponent as TongyongYouxiang } from '@web-common/images/newIcon/tongyong_youxiang.svg';
import { ReactComponent as TongyongJilu } from '@web-common/images/newIcon/tongyong_jilu.svg';
import { ReactComponent as TongyongZhiding } from '@web-common/images/newIcon/tongyong_zhiding.svg';
import { ReactComponent as TongyongGengduo } from '@web-common/images/newIcon/tongyong_gengduo.svg';
import { ReactComponent as TongyongKongxian } from '@web-common/images/newIcon/tongyong_kongxian.svg';
import { ReactComponent as TongyongRenyuan1 } from '@web-common/images/newIcon/tongyong_renyuan1.svg';
import { ReactComponent as TongyongXingxingXian } from '@web-common/images/newIcon/tongyong_xingxing_xian.svg';
import { ReactComponent as TongyongWendang3 } from '@web-common/images/newIcon/tongyong_wendang3.svg';
import { ReactComponent as TongyongMoban } from '@web-common/images/newIcon/tongyong_moban.svg';
import TongyongJiazai from '@web-common/images/newIcon/tongyong_jiazai';
import { ReactComponent as TongyongJiantouXia1 } from '@web-common/images/newIcon/tongyong_jiantou_xia1.svg';
import { ReactComponent as TongyongYidong1 } from '@web-common/images/newIcon/tongyong_yidong1.svg';
import { ReactComponent as TongyongSousuo } from '@web-common/images/newIcon/tongyong_sousuo.svg';
import { ReactComponent as TongyongShanchu } from '@web-common/images/newIcon/tongyong_shanchu.svg';
import { ReactComponent as TongyongDizhibu2 } from '@web-common/images/newIcon/tongyong_dizhibu2.svg';
import { ReactComponent as TongyongShuangjiantouYou } from '@web-common/images/newIcon/tongyong_shuangjiantou_you.svg';
import { ReactComponent as TongyongXiaoxi2Mian } from '@web-common/images/newIcon/tongyong_xiaoxi2_mian.svg';
import { ReactComponent as TongyongZijin } from '@web-common/images/newIcon/tongyong_zijin.svg';
import { ReactComponent as TongyongPaixu } from '@web-common/images/newIcon/tongyong_paixu.svg';
import { ReactComponent as TongyongDelete } from '@web-common/images/newIcon/tongyong_delete.svg';
import { ReactComponent as TongyongYouxiangMian } from '@web-common/images/newIcon/tongyong_youxiang_mian.svg';
import { ReactComponent as TongyongZhongmingming } from '@web-common/images/newIcon/tongyong_zhongmingming.svg';
import { ReactComponent as TongyongGonggao } from '@web-common/images/newIcon/tongyong_gonggao.svg';
import { ReactComponent as TongyongDianzanXianxing } from '@web-common/images/newIcon/tongyong_dianzan_xianxing.svg';
import { ReactComponent as TongyongTixing } from '@web-common/images/newIcon/tongyong_tixing.svg';
import { ReactComponent as TongyongQuxiaotixing } from '@web-common/images/newIcon/tongyong_quxiaotixing.svg';
import { ReactComponent as TongyongShuangjiantouXia } from '@web-common/images/newIcon/tongyong_shuangjiantou_xia.svg';
import { ReactComponent as bianjiHongqiMian } from '@web-common/images/newIcon/bianji_hongqi_mian.svg';
import { ReactComponent as TongyongYun } from '@web-common/images/newIcon/tongyong_yun.svg';
import { ReactComponent as TongyongXiazai2Mian } from '@web-common/images/newIcon/tongyong_xiazai2_mian.svg';
import { ReactComponent as TongyongQuanbu } from '@web-common/images/newIcon/tongyong_quanbu.svg';
import { ReactComponent as TongyongWangluoyichangMian } from '@web-common/images/newIcon/tongyong_wangluoyichang_mian.svg';
import { ReactComponent as TongyongYincang } from '@web-common/images/newIcon/tongyong_yincang.svg';
import TongyongJiantouXia from '@web-common/images/newIcon/tongyong_jiantou_xia';
import { ReactComponent as TongyongDaoru1 } from '@web-common/images/newIcon/tongyong_daoru1.svg';
import { ReactComponent as TongyongFuxuankuang } from '@web-common/images/newIcon/tongyong_fuxuankuang.svg';
import { ReactComponent as TongyongDaochu1 } from '@web-common/images/newIcon/tongyong_daochu1.svg';
import { ReactComponent as TongyongShangchuan2Xian1 } from '@web-common/images/newIcon/tongyong_shangchuan2_xian1.svg';
import { ReactComponent as TongyongShanchuMian } from '@web-common/images/newIcon/tongyong_shanchu_mian.svg';
import { ReactComponent as TongyongChehui } from '@web-common/images/newIcon/tongyong_chehui.svg';
import { ReactComponent as TongyongJianshaoXian } from '@web-common/images/newIcon/tongyong_jianshao_xian.svg';
import { ReactComponent as TongyongYidong } from '@web-common/images/newIcon/tongyong_yidong.svg';
import { ReactComponent as TongyongLiebiao } from '@web-common/images/newIcon/tongyong_liebiao.svg';
import { ReactComponent as TongyongZanting } from '@web-common/images/newIcon/tongyong_zanting.svg';
import { ReactComponent as TongyongEnter } from '@web-common/images/newIcon/tongyong_enter.svg';
import { ReactComponent as TongyongSuoKai } from '@web-common/images/newIcon/tongyong_suo_kai.svg';
import { ReactComponent as BianjiHongqi2Xian } from '@web-common/images/newIcon/bianji_hongqi2_xian.svg';
import { ReactComponent as TongyongXiazaiMian } from '@web-common/images/newIcon/tongyong_xiazai_mian.svg';
import { ReactComponent as TongyongSanlan } from '@web-common/images/newIcon/tongyong_sanlan.svg';
import { ReactComponent as TongyongYidu } from '@web-common/images/newIcon/tongyong_yidu.svg';
import { ReactComponent as TongyongFanhuichuangkou } from '@web-common/images/newIcon/tongyong_fanhuichuangkou.svg';
import { ReactComponent as TongyongShangchuan2Mian } from '@web-common/images/newIcon/tongyong_shangchuan2_mian.svg';
import { ReactComponent as TongyongXiazai } from '@web-common/images/newIcon/tongyong_xiazai.svg';
import { ReactComponent as TongyongHuiyuan } from '@web-common/images/newIcon/tongyong_huiyuan.svg';
import { ReactComponent as TongyongJiantouYou } from '@web-common/images/newIcon/tongyong_jiantou_you.svg';
import { ReactComponent as TongyongFujian } from '@web-common/images/newIcon/tongyong_fujian.svg';
import TongyongChenggongMian from '@web-common/images/newIcon/tongyong_chenggong_mian';
import { ReactComponent as TongyongWenjianjia2 } from '@web-common/images/newIcon/tongyong_wenjianjia2.svg';
import { ReactComponent as TongyongShouqi } from '@web-common/images/newIcon/tongyong_shouqi.svg';
import { ReactComponent as TongyongHuifuquanbu } from '@web-common/images/newIcon/tongyong_huifuquanbu.svg';
import { ReactComponent as TongyongWarning } from '@web-common/images/newIcon/tongyong_warn.svg';
console.log('[DiskIcons]', DiskIcons);
export default Object.assign(Object.assign(Object.assign({}, MailIcons), DiskIcons), { MaxEditor,
    MinEditor,
    AllipseGroup,
    HtmlIcon,
    Conference,
    TaskIcon,
    ImageIcon,
    InfoTips,
    JsonIcon,
    MarkdownIcon,
    Mp3Icon,
    Mp4Icon,
    AIIcon,
    ScoreSuccess,
    OtherIcon,
    PdfIcon,
    PPTIcon,
    PSIcon,
    TxtIcon,
    WordIcon,
    XlsIcon,
    ImportDocIcon,
    UploadErrorIcon,
    DownloadFailIcon,
    DownloadIcon,
    UploadIcon,
    MoreIcon,
    ZipIcon,
    SaveIcon,
    NextIcon,
    PreviousIcon,
    OpenIcon,
    CloseIcon,
    DoDownloadIcon,
    LxXlsIcon,
    LxDocIcon,
    LxUnitableIcon,
    ShrinkIcon,
    OriginalIcon,
    RotateLeft,
    AmplificationIcon,
    CircleSub,
    CirclePlus,
    SendEmailSvg,
    ContactLeft,
    ContactRight,
    Browser,
    File,
    IconFolder,
    FilterTriangleDown,
    Mark,
    Camera,
    Account,
    Expand,
    Collapse,
    Inbox,
    StarGray,
    StarGold,
    Brush,
    TemplateIcon,
    Alarm,
    EmlIcon,
    AddMember,
    MailExchange,
    Question,
    Discuss,
    GreenDiscuss,
    Descend,
    Ascend,
    Chat,
    WarnYellow,
    MailMain,
    Mail163,
    MailQq,
    MailOther,
    ResetSearch,
    ArrowUp,
    HoverShuru,
    ArrowDown,
    CrmClient,
    HintClient,
    MailComment,
    Jiantouyidong,
    TongyongCuowutishiXian,
    TongyongQingchu,
    TongyongYouxiang2,
    TongyongJiantouShang,
    TongyongZuixiaohua2,
    TongyongCaogao,
    TongyongShezhi,
    TongyongDizhibu,
    TongyongXiansuo,
    TongyongXiaoxi,
    TongyongBaocun,
    TongyongFangda,
    TongyongFanyi,
    TongyongShuomingMian,
    TongyongDingyuechenggong,
    TongyongRili3,
    TongyongTianjia,
    TongyongBiaoqianMian,
    TongyongShift,
    TongyongKuaijie,
    TongyongDianzanMianxing,
    BianjiJuhe,
    TongyongJiantouYou1,
    TongyongRili2,
    TongyongDaochu,
    TongyongDingyuerili,
    TongyongFuzhi,
    TongyongBiaoqing,
    TongyongJiantouZuo1,
    TongyongDizhi,
    TongyongXuanzhuan,
    JichuJiagou,
    Schedule,
    TongyongYouxiang4,
    TongyongShanchuMian1,
    TongyongChanpinguanli,
    TongyongJiantouShang1,
    TongyongXiaoxi3Xian1,
    TongyongXingxingMian,
    TongyongShouji,
    TongyongLianjie,
    TongyongRenwu1,
    TongyongBianjiMian,
    TongyongYouxiang5Xian,
    TongyongQiye,
    TongyongYouxiang6,
    TongyongDulichuangkou,
    TongyongShezhi2Mian,
    bianjiHuifu,
    TongyongShaixuan,
    TongyongYuyin,
    TongyongShuangjiantouShang,
    TongyongRenyuan10,
    TongyongPaizhao,
    TongyongBiaoqian2Xian,
    TongyongYiwenMian,
    TongyongYouxian,
    TongyongDiqiu,
    TongyongHoutai,
    TongyongGongju,
    BianjiHongqiXian,
    TongyongRenyuan11,
    TongyongFasong,
    TongyongZuixiaohua,
    TongyongRenwu,
    TongyongShijianXian,
    TongyongOcr,
    TongyongShuru,
    TongyongXiaoxi3Xian,
    TongyongShoujianxiang,
    TongyongZhankaiXian,
    TongyongShangchuan,
    TongyongWenjianjia,
    TongyongZuidahua,
    TongyongKuaijiejian,
    TongyongZuidahua2,
    TongyongQueren,
    TongyongSuoGuan,
    TongyongShangchuan2Xian,
    TongyongFaqizhe,
    TongyongQuxiaozhiding,
    TongyongTianjiaXian,
    TongyongRili,
    TongyongCommand,
    TongyongChenggongXian,
    TongyongGengduo2,
    TongyongGuanbiXian,
    TongyongWangluoyichangXian,
    TongyongRenyuan9,
    TongyongShanchuXian,
    TongyongGaojisousuo,
    TongyongBofang,
    TongyongShuju,
    TongyongRenyuan8,
    TongyongJianshao,
    TongyongChanpin2,
    TongyongXunhuan,
    TongyongJingshi,
    TongyongZhankaiShang,
    TongyongTupian,
    TongyongZhankaiYou,
    TongyongRenyuan5,
    TongyongBiaoqianXian,
    TongyongLishijilu,
    TongyongWendang,
    Jiantoujinyong,
    TongyongRenyuan4,
    TongyongShijianMianxing,
    TongyongFenxiang,
    TongyongXunzhang,
    TongyongShuangjiantouZuo,
    TongyongShouqiXian,
    TongyongYuedu,
    TongyongFasongMianxing,
    TongyongCuowutishiMian,
    TongyongRenyuan6,
    TongyongShuaxin,
    TongyongZhankaiXia,
    BianjiZhuanfa,
    TongyongMokuai,
    TongyongYingwen,
    TongyongRenyuan7,
    TongyongLianglan,
    TongyongDaoru,
    TongyongShuju2,
    Shuruguangbiao,
    TongyongShuomingXian,
    TongyongBangzhufankui,
    TongyongXiaoxi2Mian1,
    TongyongXinjianwenjianjia,
    TongyongDiannao,
    TongyongRenyuan3,
    TongyongShujutongji,
    TongyongYouxiang5Mian,
    TongyongShezhi2Xian,
    Subscribe,
    TongyongRenyuan2,
    TongyongZhaiyao,
    TongyongWhatsapp,
    TongyongYiwen,
    TongyongXianshi,
    TongyongZhongwen,
    TongyongJiantouZuo,
    TongyongYouxiang,
    TongyongJilu,
    TongyongZhiding,
    TongyongGengduo,
    TongyongKongxian,
    TongyongRenyuan1,
    TongyongXingxingXian,
    TongyongWendang3,
    TongyongMoban,
    TongyongJiazai,
    TongyongJiantouXia1,
    TongyongYidong1,
    TongyongSousuo,
    TongyongShanchu,
    TongyongDizhibu2,
    TongyongShuangjiantouYou,
    TongyongXiaoxi2Mian,
    TongyongZijin,
    TongyongPaixu,
    TongyongDelete,
    TongyongYouxiangMian,
    TongyongZhongmingming,
    TongyongGonggao,
    TongyongZhankaiZuo,
    TongyongDianzanXianxing,
    TongyongTixing,
    TongyongQuxiaotixing,
    TongyongShuangjiantouXia,
    bianjiHongqiMian,
    TongyongYun,
    TongyongXiazai2Mian,
    TongyongQuanbu,
    TongyongWangluoyichangMian,
    TongyongYincang,
    TongyongJiantouXia,
    TongyongDaoru1,
    TongyongFuxuankuang,
    TongyongDaochu1,
    TongyongShangchuan2Xian1,
    TongyongShanchuMian,
    TongyongChehui,
    TongyongJianshaoXian,
    TongyongYidong,
    TongyongLiebiao,
    TongyongZanting,
    TongyongEnter,
    TongyongSuoKai,
    BianjiHongqi2Xian,
    TongyongXiazaiMian,
    TongyongSanlan,
    TongyongYidu,
    TongyongFanhuichuangkou,
    TongyongShangchuan2Mian,
    TongyongXiazai,
    TongyongHuiyuan,
    TongyongJiantouYou,
    TongyongFujian,
    TongyongChenggongMian,
    TongyongWenjianjia2,
    TongyongShouqi,
    TongyongHuifuquanbu,
    TongyongWarning,
    ContentAssistantLeft,
    ContentAssistantRight });
